import React from "react"
import propTypes from "prop-types"
import { Button } from "reactstrap"
import { lenguage, dateConfig } from "config/format-date"
import { formatTicketPaymentMethods } from "utils/payment-methods"

const TicketItemList = ({ item, isOnlySeller, isDeletedView, openTicketModal }) => {
  const date = new Date(item.date.replace("Z", ""))
  const formattedDate = date.toLocaleString(lenguage, dateConfig)
  const styleCenterTable = { verticalAlign: "middle" }
  function currencyFormatter({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      minimumFractionDigits: 2,
      currency,
    })
    return formatter.format(value)
  }

  const isDeleted = Boolean(item.deleted_at)
  const paymentMethodLabel = formatTicketPaymentMethods(item)
  const isDeletedPagare = item.credit_account_status === "deleted" || (
    isDeletedView &&
    !isDeleted &&
    paymentMethodLabel.includes("Pagare")
  )
  const creditAccountStatusLabel = {
    active: "Pagare",
    paid: "Pagare pagado",
    deleted: "Pagare eliminado",
  }[item.credit_account_status]
  const statusLabel = isDeletedPagare
    ? "Pagare eliminado"
    : isDeleted
    ? "Eliminada"
    : creditAccountStatusLabel || (item.is_receivable ? "Pagare" : item.is_paid ? "Cobrada" : "Pendiente")
  const rowClassName = isDeleted || isDeletedPagare ? "deleted-row" : !item.is_paid ? "pending-row" : ""
  const formatPaymentMethod = (ticket) => {
    const payments = ticket?.ticket_payments
    const hasPayments = Array.isArray(payments) ? payments.length > 0 : Boolean(payments)

    if ((!ticket?.is_paid || ticket?.is_pending) && !hasPayments) {
      return "Pendiente"
    }

    return paymentMethodLabel
  }

  return (
    <tr key={item.id} className={rowClassName}>
      <td style={styleCenterTable} className="text-cell">
        {item.folio}
      </td>
      <td style={styleCenterTable} className="text-cell">
        {formattedDate}
      </td>
      {!isOnlySeller && (
        <td style={styleCenterTable} className="text-cell">
          {item?.user?.first_name} {item?.user?.last_name}
        </td>
      )}
      <td style={styleCenterTable} className="text-cell">
        {item?.customer?.name}
      </td>
      <td style={styleCenterTable} className="money-cell">
        {currencyFormatter({ currency: "USD", value: item.total })}
      </td>
      <td style={styleCenterTable} className="payment-method-cell">
        {formatPaymentMethod(item)}
      </td>
      <td style={styleCenterTable} className="text-cell">
        {statusLabel}
      </td>
      <td style={styleCenterTable} className="text-center">
        <Button color="success" size="sm" onClick={() => openTicketModal(item.id)} title="Ver detalles">
          <i className="fa fa-list" />
        </Button>
      </td>
    </tr>
  )
}

TicketItemList.propTypes = {
  item: propTypes.object,
  isOnlySeller: propTypes.bool,
  isDeletedView: propTypes.bool,
  openTicketModal: propTypes.func,
}

export default TicketItemList
